import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { DeviceSyncStatusResolverActions, DeviceSyncStatusApiActions } from './device-sync-status.actions';
import { mergeMap } from 'rxjs/operators';
import { DevicesService } from '@era/locations-sdk';
import { safeMap } from '@era/stores';

@Injectable()
export class DeviceSyncStatusEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: DevicesService
  ) {}

  mdmStatussesRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceSyncStatusResolverActions.syncStatusesRequested),
      mergeMap((action) =>
        safeMap(
          this.api.getDeviceSyncStatus(action.brandId, action.locationId, null, null, null),
          (list) => DeviceSyncStatusApiActions.syncStatusesLoaded({ statuses: list }),
          (error) => DeviceSyncStatusApiActions.syncStatusesLoadedError({ error })
        )
      )
    );
  });
}
